import { isFirebaseConfigured } from '@/config/env';

export { getFirebaseApp } from '@/services/firebase/firebaseApp';
export { getFirebaseAuth } from '@/services/firebase/auth';
export { getFirestoreDb } from '@/services/firebase/firestore';
export { getFirebaseStorage } from '@/services/firebase/storage';

/** Lanza si faltan variables VITE_FIREBASE_* (usar antes de init en runtime). */
export function requireFirebaseConfigured(): void {
  if (!isFirebaseConfigured()) {
    throw new Error(
      'Firebase no configurado. Copiá .env.example a .env.local y completá VITE_FIREBASE_*.',
    );
  }
}
